import Vue from "vue";
import { Component } from "vue-property-decorator";

import IgaQuickview from "@/components/quickview";

import quickview from "bulma-extensions/bulma-quickview/dist/js/bulma-quickview.min.js";
import template from "./navbar.vue";

/**
 * Navbar
 */
@Component({
  components: {
    IgaQuickview,
  },
  mixins: [template],
})
export default class NavBar extends Vue {
  /**
   * Menu collapsé
   * @type {boolean}
   */
  protected burger: boolean = false;
  /**
   * Menu collapsé
   * @type {boolean}
   */
  protected quickview: any = {};

  /**
   * Lifecycle : chargement du quickview
   * @return {void}
   */
  protected mounted(): void {
    this.quickview = quickview.attach();
  }
  /**
   * Toogle l'état callapsé du menu
   * @return {void}
   */
  protected toggleMenu(): void {
    this.burger = !this.burger;
  }

}
